<template>
  <div 
    class="Popup" 
    :class="{ 'Popup--visible': visible, 'Popup--mobile': mobile }" 
    :style="{ width: responsiveWidth, marginLeft: marginLeft }">
    <h2>{{ title }}</h2>
    <svg  
      aria-hidden="true" 
      focusable="false" 
      data-prefix="fal"  
      data-icon="times" 
      class="svg-inline--fa fa-times fa-w-10" 
      role="img" 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 320 512"
      @click="handleClose">
      <path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path>
    </svg>
    <div class="Popup__content">
      <VueMarkdown 
        :source="content" 
        :anchorAttributes="{ target: '_blank' }" />
    </div>
  </div>
</template>

<script>

import VueMarkdown from 'vue-markdown'

export default {
  name: 'Popup',
  components: { VueMarkdown },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    mobile: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '275px'
    }
  },
  computed: {
    responsiveWidth() {
      return this.mobile ? '100%' : this.width
    },
    marginLeft() {
      return this.visible ? 0 : `calc( -1 * ${this.responsiveWidth})`
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.Popup {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 275px;
  background: white;
  z-index: 99999;
  padding: 20px;
  margin-left: -275px;
  transition: margin 0.3s ease-in-out, width 0.3s ease-in-out;
  overflow-y: scroll;

  &--mobile {
    width: 100%;
    margin-left: -100%;
  }

  &--visible {
    margin-left: 0;
    box-shadow: inset -1px 0 0 0 #dfe2e5;
  }

  svg {
    position: absolute;
    right: 12px;
    top: 22px;
    height: 24px;
    width: 24px;
    cursor: pointer;
  }

  h2 {
    margin: 0;
    padding: 0;
    margin-top: 3px;
    color: #3AAA35;
    padding-right: 20px;
    font-size: 20px;
    font-weight: 700;
  }
}
</style>